import store from "../store"
export function getmenu(){
  let target = store.state.permission.addRoutes.filter(
    el => el.path == "/home/seal"//遍历每一个数组，过滤出返回值委true的值
  );

  // if(target[0].children.filter(el=>el.path=="SealApprove").length<=0){
  //   var foundIndex = target[0].children.findIndex(x => x.path == "sealrecord");
  //   if(foundIndex!=-1){
  //     target[0].children[foundIndex].hidden= false;
  //     // console.log("seal")
  //   }
  // }
  // if(target[0].children.filter(el=>el.path=='BidApprove').length<=0){
  //   var foundIndex = target[0].children.findIndex(x => x.path == "Bidrecord");
  //   if(foundIndex!=-1){
  //     target[0].children[foundIndex].hidden= false;
  //     // console.log("Bid")
  //   }
  // }
  return target
}
export function changerouter(arr,value){
  arr= arr.filter(el=>el.meta.menu==value)
  return arr
}
